// components/bando-card/bando-card.component.ts
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Bando } from 'src/app/services/obiettivo-europa.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-bando-card',
  templateUrl: './bando-card.component.html',
  styleUrls: ['./bando-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ],
})
export class BandoCardComponent {
  @Input() bando!: Bando;
  @Output() favoriteToggle = new EventEmitter<number>();


  constructor(private router: Router) {
  }

  getStatusLabel(status: number): string {
    return status === 1 ? 'Aperto' : 'In uscita';
  }

  getStatusClass(status: number): string {
    return status === 1 ? 'status-open' : 'status-closed';
  }

  formatDeadlineMessage(days: number, deadline: string): string {
    let stringDeadline = 'Scadenza:' + deadline;
    if (days) {
      stringDeadline += ' (' + days + ' giorni alla scadenza)';
    }
    return stringDeadline;
  }

  onFavoriteClick(): void {
    this.favoriteToggle.emit(this.bando.id);
  }

  getVisibleSectors(): any[] {
    return this.bando.sectors.slice(0, 5);
  }

  getHiddenSectorsCount(): number {
    return Math.max(0, this.bando.sectors.length - 5);
  }
  goToProduct() {
     this.router.navigate([environment.routingBasePath + '/product/obiettivo-europa']);
  }
 
}